import { Navigate, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "@charisol-spark/ui";
import { LandingPage } from "./LandingPage";
import { PricingPage } from "./PricingPage";
import { PrivacyPolicyPage } from "./PrivacyPolicyPage";
import { TermsOfServicePage } from "./TermsOfServicePage";
import { DataDeletionPage } from "./DataDeletionPage";
import { NotFound } from "./NotFound";

/**
 * Public marketing routes.
 *
 * Anything under /app, /auth or /onboarding belongs to the application
 * bundle and is reached by a full document load; see bundleBoundary.ts for
 * why a <Link> would not work.
 */
export function SiteRouter() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/data-deletion" element={<DataDeletionPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}
